import { Observable } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';
import { AngularFirestore } from '@angular/fire/firestore';

export class TranslateFireLoader implements TranslateLoader {
    constructor(private readonly db: AngularFirestore) {}

    public getTranslation(lang: string, prefix: string = 'translates/'): Observable<any> {
        return this.db.doc(`${ prefix }${ lang }`).valueChanges();
    }
}
